<template>
  <div>
    <v-row class="mx-3">
      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="company"
          v-validate="'required'"
          :loading="loading"
          :items="companies"
          :error-messages="errors.collect('company')"
          data-vv-name="company"
          data-vv-as="company"  
          item-text="name"
          item-value="id"
          label="Company"
          outlined
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="payrollPeriod"
          v-validate="'required'"
          label="Payroll Period"
          :items="payrollPeriods"
          :item-text="item => $moment(item.payroll_date).format('MMM YYYY')"
          item-value="id"
          outlined
          :error-messages="errors.collect('payrollPeriod')"
          data-vv-name="payrollPeriod"
          data-vv-as="payroll period"  
        />
      </v-col>
        
      <v-col cols="6">
        <v-text-field
          v-model="receiptNo"
          v-validate="'required'"
          label="Receipt/Bank Slip/Transaction No"
          :error-messages="errors.collect('receiptNo')"
          outlined
          data-vv-name="receiptNo"  
          data-vv-as="Receipt No"
        />
      </v-col>
      <v-col cols="6">
        <v-menu
          v-model="transactionDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="transactionDate"
              v-validate="'required'"
              label="Transaction date"
              outlined
              readonly
              class="label-position"
              :error-messages="errors.collect('transactionDate')"
              data-vv-name="transactionDate"
              data-vv-as="Transaction Date"  
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="transactionDate"
            no-title
            @input="transactionDateMenu = false"
          />
        </v-menu>
      </v-col>

      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          color="hrissecondary"
          class="white--text"
          :loading="progressing"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
    },
    data () {
      return {
        companies: [],
        company: null,
        payrollPeriods: [],
        payrollPeriod: null,
        loading: false,
        progressing: false,
        receiptNo: null,
        transactionDateMenu: false,
        transactionDate: null,
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.payrollPeriods().list('?status=closed'),
        this.$api.hrisCompanies().list('?filter_by=organization'),
      ])
        .then(([payrollPeriod, company]) => {
          this.payrollPeriods = payrollPeriod.data        
          this.companies = company.data

          this.loading = false
        })
    },
    methods: {
      submit () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.pcbArrears().create(this.prepareFormData())
              .then((res) => {
                this.$snack({ message: res.data.status })
              
                this.$validator.reset()
                this.company = null
                this.payrollPeriod = null
                this.receiptNo = null
                this.transactionDate = null
              }).catch((e) => {
                this.$snack({ 
                  color: 'error',
                  message: e.response.data.message, 
                })
              }).then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          company: this.company,
          payroll_period: this.payrollPeriod,
          pcb_receipt_no: this.receiptNo,
          pcb_transaction_date: this.transactionDate,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
